import { FORM_BUILDER_IMAGE } from "../constants/constants";

const initialState = [];

export const uploadFormbuilderimageReducers = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case FORM_BUILDER_IMAGE:
      return payload;

    default:
      return state;
  }
};
